import { RadioGroupItem as RadioGroupItemComponent } from "../../../ui/radio-group";
import { Label } from "../../../ui/label";
import { cn } from "../../../utils";
import { RadioGroupItemProps } from "../types";
import { LabelWithDescription } from "../../../common/LabelWithDescription";

export const RadioGroupItem = ({
  value = "",
  disabled,
  error,
  name = "radio",
  label,
  description,
  wrapperClassName,
  labelClassName,
  descriptionClassName,
  labelWrapperClassName,
}: React.PropsWithChildren<RadioGroupItemProps>) => {
  const optionId = `${name}-${value}`;

  return (
    <Label
      key={value}
      htmlFor={optionId}
      className={cn(
        "group/radio-item flex items-start p-4 rounded-lg gap-2 transition-all duration-200",
        "font-normal leading-5 cursor-pointer",
        "has-[button:disabled]:cursor-not-allowed has-[button:disabled]:hover:bg-transparent",
        {
          "cursor-pointer": !disabled,
          "!cursor-not-allowed hover:!bg-transparent": disabled,
          "border border-destructive": error,
        },
        wrapperClassName,
      )}
    >
      <RadioGroupItemComponent
        value={value}
        id={optionId}
        disabled={disabled || error}
      />
      <LabelWithDescription
        label={label}
        description={description}
        disabled={disabled}
        labelClassName={labelClassName}
        descriptionClassName={descriptionClassName}
        labelWrapperClassName={labelWrapperClassName}
      />
    </Label>
  );
};

RadioGroupItem.displayName = "RadioGroupItemComponent";
